import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { TrashIcon } from '../../assets/icons';
import DeviceIcon from '../../assets/symbols/device.svg';
import DeviceIconDark from '../../assets/symbols/device_dark.svg';

import styles from './Device.module.scss';

const Device = React.memo(({ isError, elementId, attachment, device, items, onDelete }) => {
  const handleDeteleDevice = () => {
    onDelete(elementId);
  };

  const listItems = [];
  items.forEach((item) => {
    if (item.modelId === device.modelId) {
      listItems.push(item);
    }
  });

  return (
    <>
      <div className={styles.deviceItemWrapper}>
        <Button className={styles.buttonDelete} onClick={handleDeteleDevice}>
          <TrashIcon className={styles.menuIcon} />
        </Button>
        <div className={styles.deviceStatus}>
          <span className={isError ? styles.statusError : styles.statusActive}>
            {device.status}
          </span>
        </div>
        <div className={styles.detailWrapper}>
          <div className={styles.deviceLogo}>
            <img src={attachment?.coverUrl || DeviceIcon} alt="Logo" className={`white-block `} />
            <img
              src={attachment?.coverUrl || DeviceIconDark}
              alt="Logo"
              className={`dark-block `}
            />
          </div>
          <div className={styles.detailHeader}>{device.name}</div>
          <div className={styles.detailContent}>
            <ul className={styles.listItems}>
              {listItems.map((item) => {
                if (item.basic) {
                  return (
                    <li key={item.id}>
                      <div className={styles.label}>{item.name}</div>
                      <div className={styles.contentValue}>
                        <div className={styles.value}>
                          {device.status === 0 && !Number.isNaN(device.items?.[item.itemName] * 1)
                            ? parseFloat(device.items?.[item.itemName]).toLocaleString('en-GB', {
                                minimumFractionDigits: item.decimalPoint,
                                maximumFractionDigits: item.decimalPoint,
                              })
                            : '-'}
                        </div>
                        <div className={styles.unit}>{item.unitName}</div>
                      </div>
                    </li>
                  );
                }
                return '';
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
});

Device.propTypes = {
  isError: PropTypes.bool.isRequired,
  attachment: PropTypes.objectOf(PropTypes.any),
  elementId: PropTypes.string.isRequired,
  device: PropTypes.objectOf(PropTypes.any).isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  onDelete: PropTypes.func.isRequired,
};

Device.defaultProps = {
  attachment: undefined,
};

export default Device;
